/** Placeholder for a cell with no value — or a column the API has no data for yet. */
export const EMPTY_CELL = '—';

// `timeZone: 'UTC'` matters: the date is read and formatted in the same zone, so a calendar day never moves with the
// viewer's timezone (the app has no timezone setting). A bare `YYYY-MM-DD` is read as UTC midnight and shown in UTC;
// reading it as local midnight and showing it in UTC made it a day early anywhere ahead of UTC (CET, for one).
// `daysUntil` below parses Y/M/D as UTC for the same reason.
const DATE_FORMAT: Intl.DateTimeFormatOptions = {day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC'};

/**
 * `YYYY-MM-DD` (or an ISO datetime) as "30 Jun 2027"; `EMPTY_CELL` when there is no date. `locale` is the deployment's
 * locale where the page has one (Category Profile: `C.profile.locale`).
 */
export function formatDate(value: string | null, locale = 'en-GB'): string {
    if (!value) return EMPTY_CELL;
    const date = /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T00:00:00Z`) : new Date(value);
    return date.toLocaleDateString(locale, DATE_FORMAT);
}

/** Whole calendar days from today until `date` — negative once it is in the past. */
export function daysUntil(date: string | null): number | null {
    if (!date) return null;
    const [year, month, day] = date.slice(0, 10).split('-').map(Number);
    const target = Date.UTC(year, month - 1, day);
    const now = new Date();
    const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    return Math.round((target - today) / (24 * 60 * 60 * 1000));
}
